"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
const axios_1 = __importDefault(require("axios"));
const debug_1 = require("./util/debug");
const types_1 = require("./types");
const Processor_1 = __importDefault(require("./Processor"));
var EventType;
(function (EventType) {
    EventType["Init"] = "init";
    EventType["Data"] = "data";
    EventType["End"] = "end";
    EventType["Error"] = "error";
    EventType["Pause"] = "pause";
})(EventType || (exports.EventType = EventType = {}));
class Requestor {
    constructor(options) {
        this.dns = options.dns;
        this.wKey = null;
        this.isRuntime = options.isRuntime;
        this.proto = options.proto || types_1.ProtoType.Https;
        this.serverType = options.serverType || types_1.ServerType.Wuji;
        this.debugConsole = !!options.debug ? console : debug_1.fakeConsole;
        if (this.serverType === types_1.ServerType.Common) {
            if (!options.wKey) {
                throw new Error('使用 Paas 服务必须要传入平台申请的 wKey！');
            }
            this.wKey = options.wKey;
        }
    }
    // 发送单条聊天消息，后台存储上下文
    async send(message, options = {}) {
        return await this.doPost(message, types_1.ApiType.Line, {
            logTagBase: `--- sdk.send - sessionId: ${message.sessionId || null} ---`,
            options,
        });
    }
    // 发送全部聊天记录，后台不会拼接上下文
    async sendAll(messages, options = {}) {
        return await this.doPost(messages, types_1.ApiType.Batch, {
            logTagBase: `--- sdk.sendAll - sessionId: ${messages.sessionId || null} ---`,
            options,
        });
    }
    get basePath() {
        if (this.serverType === types_1.ServerType.Common) {
            return '/chat/';
        }
        if (this.serverType === types_1.ServerType.Wuji) {
            return `/api/xy${this.isRuntime ? '/runtime' : ''}/chat/`;
        }
    }
    async doPost(messages, apiType, { logTagBase, options } = {}) {
        var _a, _b, _c, _d, _e;
        const logTag = new debug_1.LogTag(logTagBase || `--- post message to server - sessionId: ${messages.sessionId || null} ---`);
        let isPause = false;
        const chunkProcessor = new Processor_1.default({
            logTag,
            debugConsole: this.debugConsole,
            onStop: () => {
                isPause = true;
            },
        });
        const { system = 'azure', queryStr = '' } = options || {};
        this.debugConsole.log(logTag.begin, messages);
        if (Object.keys((messages === null || messages === void 0 ? void 0 : messages.modelConfig) || {}).length === 0) {
            // eslint-disable-next-line no-param-reassign
            delete messages.modelConfig;
        }
        const headers = {
            'content-type': 'application/json',
            ...(this.getAuthHeaders()),
        };
        if (typeof window === 'object') {
            // 浏览器端
            const projectId = window.w.projectId || window.w.query.projectid || '';
            const pageId = ((_a = window.w.mainPageInfo) === null || _a === void 0 ? void 0 : _a.pageId) || window.w.query.pageid || '';
            const query = new URLSearchParams(queryStr);
            if (projectId) {
                query.set('projectId', projectId);
            }
            if (pageId) {
                query.set('pageId', pageId);
            }
            if (system) {
                query.set('system', system);
            }
            const finalQueryString = query.toString() ? `?${query.toString()}` : '';
            const url = `${this.proto}://${this.dns}${this.basePath}${apiType}${finalQueryString}`;
            const response = await fetch(url, {
                method: 'post',
                body: JSON.stringify(messages),
                headers,
                credentials: 'include',
            });
            const reader = (_b = response.body) === null || _b === void 0 ? void 0 : _b.getReader();
            const decoder = new TextDecoder();
            const read = async () => {
                const readRes = await (reader === null || reader === void 0 ? void 0 : reader.read());
                if (!readRes) {
                    return;
                }
                const { done, value } = readRes;
                const tmp = decoder.decode(value, { stream: !done });
                chunkProcessor.handleChunk(tmp, done);
                if (done || isPause) {
                    return;
                }
                await read();
            };
            read();
        }
        else {
            // nodejs fetch
            const finalQueryString = queryStr ? `?${queryStr}` : '';
            const url = `${this.proto}://${this.dns}/${system || 'openai'}${this.basePath}${apiType}${finalQueryString}`;
            const response = await axios_1.default.post(url, messages, {
                responseType: 'stream',
                headers,
                maxRedirects: 0,
            });
            (_c = response.data) === null || _c === void 0 ? void 0 : _c.on('data', (tmp) => {
                chunkProcessor.handleChunk(`${tmp || ''}`, false);
            });
            (_d = response.data) === null || _d === void 0 ? void 0 : _d.on('error', (e) => {
                chunkProcessor.logAndEmit(EventType.Error, e);
            });
            (_e = response.data) === null || _e === void 0 ? void 0 : _e.on('close', () => {
                chunkProcessor.handleChunk('', true);
            });
        }
        return chunkProcessor;
    }
    getAuthHeaders() {
        return this.serverType === types_1.ServerType.Common ? { Authorization: `Bearer ${this.wKey}` } : {};
    }
}
exports.default = Requestor;
